import { Injectable } from "@angular/core";
import { HttpService } from "../http/http.service";
import { Observable, of } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class MeetingService {

    constructor(private readonly _http: HttpService) { }

    getMeetings(): Observable<any> {
        return this._http.get('rest/v1/calendar_meetings?select=*&bot_status=neq.done');
    }

    getCompletedOpportunityMeetings(limit = 20, offset = 0, from: string | null = null, to: string | null = null): Observable<any> {
        return this._http.post(
            'rest/v1/rpc/get_completed_opportunity_meetings',
            { p_limit: limit, p_offset: offset, p_from: from, p_to: to },
            false
        );
    }

    sendEmail(meeting_bot_id: string, email_list: string[]): Observable<any> {
        return this._http.post('functions/v1/send-email-end', { meeting_bot_id, email_list });
    }
}